<!--
    @Author : Luo
    @Time   : 2020/8/8 9:44
-->
<template>
  <div class="account_analysis_page">
    <div :class="'page_nav' + (!catAccountStatus ? ' page_nav_full' : '')">
      <div class="page_nav_header flex_center">
        <template v-if="catAccountStatus">
          <router-link :to="{path: '/home/user/index', query: {team: teamIndex}}">
            <span>账号概览</span>
          </router-link>
        </template>
        <template v-else>
          <router-link :to="{path: '/home/user/index', query: {account: 'true', team: catUserInfo['team'], id: catUserInfo['id'], name: catUserInfo['name']}}">
            <span>账号概览</span>
          </router-link>
        </template>
        <div class="page_nav_breadcrumb"><span>/</span></div>
        <div class="now_page_label">
          <span>视频分析</span>
        </div>
      </div>
      <div class="page_nav_content flex_center">
        <div class="account_info_item flex_center">
          <div class="account_info_container flex_center account_user" v-if="accountDate.firstname && accountDate.firstname.length > 0">
            <div class="account_label">
              <span>用户名</span>
            </div>
            <div class="account_info_content text_ellipsis text_left">
              <span>{{ accountDate.firstname }}</span>
            </div>
          </div>
          <div class="account_info_container flex_center account_user" v-if="accountDate.account && accountDate.account.length > 0">
            <div class="account_label">
              <span>账号</span>
            </div>
            <div class="account_info_content text_ellipsis text_left">
              <span>{{ accountDate.account }}</span>
            </div>
          </div>
          <div class="account_info_container flex_center account_user" v-if="accountDate.nickname && accountDate.nickname.length > 0">
            <div class="account_label">
              <span>微信名</span>
            </div>
            <div class="account_info_content text_ellipsis text_left">
              <span>{{ accountDate.nickname }}</span>
            </div>
          </div>
        </div>
        <div class="account_info_item flex_center">
          <div class="account_info_container flex_center account_client">
            <div class="account_label flex_center">
              <span>视频开放阶段</span>
            </div>
            <div class="account_info_content flex_center">
                <span>
                  {{ accountDate.stage }}
                </span>
            </div>
          </div>
          <div class="account_info_container flex_center account_active">
            <div class="account_label">
              <span>视频观看总进度</span>
            </div>
            <div class="account_info_content flex_center">
              <div class="progress_bg text_left">
                <span :class="0 <= accountDate.progress && accountDate.progress <= 35 ? 'progress_red' : (35 < accountDate.progress && accountDate.progress <= 70 ? 'progress_blue' : 'progress_green')"
                      :style="'width: ' + accountDate.progress + '%'"></span>
              </div>
              <span style="margin-left: 15px">{{ accountDate.progress + '%' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="account_page_container">
      <div class="account_page_header flex_center">
        <div class="page_wait_time flex_center">
          <div class="page_wait_time_container flex_center">
            <div class="page_wait_time_info"><span>{{ setTimeType(accountDate.time) }}</span></div>
            <div class="page_wait_time_label"><span>视频观看用时</span></div>
          </div>
        </div>
        <div class="account_page_search flex_center">
          <div v-for="(item, i) in stageSearchDate" :key="i"
               :data-id="item.id" @click="setStage(item.id)"
               :class="'account_video_stage_container ' + (item.id === stageCurrent ? 'account_video_stage_active' : '')">
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="account_page_main text_left">
        <div class="account_page_main_header flex_center">
          <div class="account_page_main_client"><span>课时</span></div>
          <div class="account_page_main_member"><span>开放阶段</span></div>
          <div class="account_page_main_page"><span>观看进度</span></div>
          <div class="account_page_main_time"><span>观看时长</span></div>
        </div>
        <div class="account_page_main_list flex_center">
          <div class="no_user_hint text_center" v-if="JSON.stringify(tempClientDate).length <= 2"><span>{{ noDataHint }}</span></div>
          <div class="account_page_main_client_container flex_center" v-for="(item, i) in tempClientDate['current' + pagination.current]" :key="i">
            <div class="account_page_main_client"><span>{{ item.name}}</span></div>
            <div class="account_page_main_member"><span>{{ item.stage }}</span></div>
            <div class="account_page_main_page flex_center">
              <div class="progress_bg text_left">
              <span :class="0 <= item.progress && item.progress <= 35 ? 'progress_red' : (35 < item.progress && item.progress <= 70 ? 'progress_blue' : 'progress_green')"
                    :style="'width: ' + item.progress + '%'"></span>
              </div>
              <span style="margin-left: 15px">{{ item.progress + '%' }}</span>
            </div>
            <div class="account_page_main_time"><span>{{ setTimeType(item.time) }}</span></div>
          </div>
        </div>
      </div>
      <div>
        <pagination :key="pagination.length" :default-current="pagination.current" :length="pagination.length" :default-amount="pagination.amount" v-on:pageCurrent="pageCurrent" />
      </div>
    </div>
  </div>
</template>

<script>
import pagination from '@/components/pagination/index'
import { _Ajax, initLogin, logout } from '@/api/_axios'
import { newMap, setTimeType, resetSpecNum } from '@/components/common/common_js'

export default {
  name: 'accountAnalysisPage',
  components: {
    pagination
  },
  data () {
    return {
      title: '',
      accoundId: null,
      setTimeType: setTimeType,
      resetSpecNum: resetSpecNum,
      stageSearchDate: [], // 阶段数据
      stageCurrent: 1000, // 阶段下标
      clientDate: {}, // 存储的所有客户数据
      tempClientDate: {}, // 页面显示的客户数据
      noDataHint: '',
      pagination: {
        length: 0,
        amount: 10,
        current: 1
      },
      accountDate: {}, // 账号概览传过来的数据
      teamIndex: 0,
      catAccountStatus: true,
      catUserInfo: {}
    }
  },
  methods: {
    // 设置阶段
    setStage: function (v) {
      this.stageCurrent = v
      this.pagination.length = this.clientDate['stage' + this.stageCurrent].length
      this.pagination.current = 1
      this.setUserDate(this.clientDate['stage' + this.stageCurrent])
    },
    // 设置客户的数据 arr: 数组, amount: 条目
    setUserDate: function (arr) {
      let tempArr = []
      let amount = this.pagination.amount
      let tempAmount = Math.ceil(this.pagination.length / amount)
      this.tempClientDate = {}
      for (let i = 1; i <= tempAmount; i++) {
        newMap(arr, (e, j) => {
          if (amount * ((i - 1) <= 0 ? 0 : i - 1) <= j && amount * i > j) {
            tempArr.push(e)
          }
        })
        this.tempClientDate['current' + i] = tempArr
        tempArr = []
      }
    },
    pageCurrent: function (data) {
      this.pagination.current = data.current
      // 选择每页显示条数的时候在刷新列表、条目及组件
      if (data.event === 'amount') {
        this.pagination.amount = data.amount
        this.setUserDate(this.clientDate['stage' + this.stageCurrent])
      }
    },
    // 获取客户换看视频数据
    getClientVideoDate: function () {
      let that = this

      that.clearUserData()
      _Ajax(
        {
          method: 'get',
          url: '/data/user/video/' + that.accoundId,
          clearCancelSource: true
        },
        (res) => {
          if (res.status === 401) {
            setTimeout(() => {
              that.$notice({type: 'error', content: '账号概览 - 视频分析：认证令牌错误！'})
              logout(that.$router)
            }, 0)
          } else if (res.status === 200) {
            res = res.data

            if (res.code && res.code === 'err100104') {
              that.noDataHint = '暂无客户数据'
              that.$notice({type: 'error', content: `错误：该用户的视频分析${res.msg}`})
              return false
            }
            that.stageSearchDate = [{name: '全部', id: 1000}]
            let tempStage = false // 判断阶段是否存在

            if (res.videoList && res.videoList.length > 0) {
              newMap(res.videoList, (e, j) => {
                // 全部数据
                if (!that.clientDate['stage1000']) {
                  that.clientDate['stage1000'] = []
                }
                that.clientDate['stage1000'].push({progress: that.resetSpecNum(e.playProgress), time: e.playTotalTime, name: e.videoName, stage: e.courseName})

                // 存储阶段数据
                tempStage = false
                if (that.stageSearchDate.length > 0) {
                  for (let item of that.stageSearchDate) {
                    // 判断是否有该阶段
                    if (e.courseName === item.name) {
                      that.clientDate['stage' + item.id].push({progress: that.resetSpecNum(e.playProgress), time: e.playTotalTime, name: e.videoName, stage: e.courseName})
                      tempStage = true
                    }
                  }
                }
                if (!tempStage) {
                  // 存储各阶段客户数据
                  if (!that.clientDate['stage' + j]) {
                    that.clientDate['stage' + j] = []
                  }
                  that.stageSearchDate.push({name: e.courseName, id: j})
                  that.clientDate['stage' + j].push({progress: that.resetSpecNum(e.playProgress), time: e.playTotalTime, name: e.videoName, stage: e.courseName})
                }
              })

              that.pagination.length = that.clientDate['stage' + that.stageCurrent].length

              that.setUserDate(that.clientDate['stage' + that.stageCurrent])
            } else {
              that.noDataHint = '该团队下暂无账号'
            }

            that.accountDate = {
              account: res.userName,
              progress: res.playTotalProgress,
              time: res.videoTotalTime,
              stage: res.level,
              firstname: res.firstname,
              nickname: res.nickname
            }
          }
        },
        (rej) => { console.log('b--', rej) }
      )
    },
    // 清空数据
    clearUserData: function () {
      let that = this

      that.noDataHint = '数据正在加载中...'
      that.pagination.length = 0
      that.pagination.current = 1
      that.clientDate = {}
      that.setUserDate([])
    }
  },
  mounted () {},
  beforeMount: function () {
    let that = this
    let tempRoute = that.$route.query

    that.teamIndex = tempRoute.team
    that.accoundId = tempRoute.id

    if (tempRoute.account && tempRoute.account === 'true') {
      that.catAccountStatus = false
      that.catUserInfo['name'] = tempRoute.name
      that.catUserInfo['team'] = Number(tempRoute.team)
      that.catUserInfo['id'] = tempRoute.accountId
    }

    console.log('fff-', that.$route, that.catAccountStatus, that.catUserInfo)

    this.getClientVideoDate()
  },
  beforeCreate: function () {
    initLogin(this.$router)
  }
}
</script>

<style scoped>
.page_nav {position: absolute;top: 80px;padding: 20px 0 20px 28px;margin-left: -28px;width: calc(100vw - 272px);background-color: rgba(255, 255, 255, 1)}
.page_nav_full {width: 100%;min-width: 1306px}
.page_nav_content {flex-flow: column;align-items: flex-start;justify-content: flex-start;margin-top: 24px}
.account_info_item {justify-content: flex-start}
.account_info_item:not(:first-of-type) {margin-top: 20px}
.account_info_container {min-width: 260px;justify-content: flex-start}
.account_info_container:not(:first-of-type) {margin-left: 20px}
.account_client {width: 170px}
.account_label {white-space: nowrap}
.account_label span {font-size: 12px;font-weight: bold;color: rgba(102, 102, 102, 1)}
.account_info_content {margin-left: 16px}
.account_info_content span {font-size: 14px;font-weight: bold;color: rgba(40, 40, 40, 1)}
.account_page_container {padding: 30px 32px;margin-top: 124px;background-color: rgba(255, 255, 255, 1);border-radius: 6px}
.account_page_header {justify-content: space-between}
.page_wait_time {justify-content: space-between}
.page_wait_time_container {justify-content: flex-start;flex-flow: column;align-items: flex-start}
.page_wait_time .page_wait_time_container:not(:first-of-type) {margin-left: 100px}
.page_wait_time_info span {font-size: 28px;font-weight: 500;color: rgba(40, 40, 40, 1)}
.page_wait_time_label {margin-top: 12px}
.page_wait_time_label span {font-size: 16px;font-weight: 500;color: rgba(48, 48, 48, 1)}

.account_page_search {justify-content: flex-end}
.account_page_search .account_video_stage_container {line-height: 38px;width: 82px;height: 38px;background: rgba(255, 255, 255, 1);border: 1px solid rgba(219, 219, 219, 1)}
.account_video_stage_container span {font-size: 14px;font-weight: 400;color: rgba(40, 40, 40, 1);line-height: 38px}
.account_page_search .account_video_stage_active {width: 80px;height: 36px;border: 2px solid rgba(76, 139, 255, 1)}
.account_page_search .account_video_stage_active span {color: rgba(76, 139, 255, 1)}
.account_page_search .account_video_stage_container:first-of-type {border-radius: 4px 0 0 4px}
.account_page_search .account_video_stage_container:last-of-type {border-radius: 0 4px 4px 0}

.account_page_main {margin-top: 20px}
.account_page_main_header {justify-content: flex-start;padding: 0 23px;height: 50px;background-color: rgba(248, 248, 248, 1)}
.account_page_main_header span {font-size: 14px;font-weight: 400;color: rgba(102, 102, 102, 1)}
.account_page_main_client_container {justify-content: flex-start;padding: 0 23px;width: calc(100% - 46px);height: 50px;border-bottom: 1px solid rgba(235, 235, 235, 1)}
.account_page_main_header > div:not(:first-of-type) .account_page_main_client_container > div:not(:first-of-type) {margin-left: 20px}
.account_page_main_client_container span {font-size: 14px;font-weight: 500;color: rgba(40, 40, 40, 1)}
.account_page_main_client {width: 250px}
.account_page_main_member {width: 210px}
.account_page_main_page {width: 340px;justify-content: flex-start}
.account_page_main_time {width: 150px}
.account_page_main_list {flex-flow: column;justify-content: flex-start;align-items: flex-start}

.progress_bg {width: 120px;background-color: rgba(240, 242, 245, 1);border-radius: 3px;line-height: 0}
.progress_bg span {height: 6px;border-radius: 3px;display: inline-block}
.progress_bg .progress_red {background: rgba(245, 72, 88, 1)}
.progress_bg .progress_blue {background: rgba(76, 139, 255, 1)}
.progress_bg .progress_green {background: rgba(51, 239, 130, 1)}

.no_user_hint {margin: 30px 0;width: 100%}
.no_user_hint span {font-size: 16px;font-weight: 500;color: rgba(143, 143, 143, 1)}
</style>



// WEBPACK FOOTER //
// src/components/page-user/video-analysis.vue